import { render, staticRenderFns } from "./QuizzesAndReschedules.vue?vue&type=template&id=2154c359&scoped=true&"
import script from "./QuizzesAndReschedules.vue?vue&type=script&lang=js&"
export * from "./QuizzesAndReschedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2154c359",
  null
  
)

export default component.exports